/* =============================================================================
   Monolith — navigation.js
   Header behaviour: desktop dropdowns, mobile menu, inline search bar,
   localization form auto-submit, header height CSS variable.
   ============================================================================ */
(function () {
  'use strict';

  function initHeader(header) {
    if (!header || header.dataset.headerBound) return;
    header.dataset.headerBound = 'true';

    /* ------------------------------------------------ Desktop dropdowns */
    const navItems = header.querySelectorAll('[data-nav-item]');
    navItems.forEach((details) => {
      // Hover intent (open on hover, close on leave) + click toggle for touch/keyboard
      let closeTimer;
      details.addEventListener('mouseenter', () => {
        clearTimeout(closeTimer);
        details.open = true;
      });
      details.addEventListener('mouseleave', () => {
        closeTimer = setTimeout(() => {
          details.open = false;
        }, 120);
      });
      details.addEventListener('toggle', () => {
        if (details.open) {
          navItems.forEach((other) => {
            if (other !== details) other.open = false;
          });
        }
      });
    });

    document.addEventListener('click', (event) => {
      navItems.forEach((details) => {
        if (details.open && !details.contains(event.target)) details.open = false;
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') navItems.forEach((details) => (details.open = false));
    });

    /* ------------------------------------------------ Mobile menu */
    const mobileToggle = header.querySelector('[data-mobile-nav-toggle]');
    const mobileNav = header.querySelector('[data-mobile-nav]');
    const mobileBackdrop = header.querySelector('[data-mobile-nav-backdrop]');

    function openMobileNav() {
      if (!mobileNav) return;
      mobileNav.hidden = false;
      if (mobileBackdrop) mobileBackdrop.hidden = false;
      void mobileNav.offsetWidth;
      mobileNav.classList.add('is-open');
      if (mobileBackdrop) mobileBackdrop.classList.add('is-visible');
      mobileToggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('header-mobile-menu-open');
      theme.lockScroll();
    }

    function closeMobileNav() {
      if (!mobileNav || !mobileNav.classList.contains('is-open')) return;
      mobileNav.classList.remove('is-open');
      if (mobileBackdrop) mobileBackdrop.classList.remove('is-visible');
      mobileToggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('header-mobile-menu-open');
      theme.unlockScroll();
      setTimeout(() => {
        if (!mobileNav.classList.contains('is-open')) {
          mobileNav.hidden = true;
          if (mobileBackdrop) mobileBackdrop.hidden = true;
        }
      }, 240);
    }

    if (mobileToggle && mobileNav) {
      mobileToggle.addEventListener('click', () => {
        mobileNav.classList.contains('is-open') ? closeMobileNav() : openMobileNav();
      });
      if (mobileBackdrop) mobileBackdrop.addEventListener('click', closeMobileNav);
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeMobileNav();
      });
      // Close when a drawer opens (cart, search)
      theme.events.on(theme.EVENTS.drawerOpen, closeMobileNav);
    }

    /* ------------------------------------------------ Inline search */
    header.querySelectorAll('[data-search-toggle]').forEach((toggle) => {
      const pill = toggle.closest('[data-header-pill]');
      const form = pill && pill.querySelector('[data-search-form]');
      const input = form && form.querySelector('[data-search-input]');
      const closeBtn = form && form.querySelector('[data-search-close]');
      if (!pill || !form || !input) return;

      const open = () => {
        closeMobileNav();
        pill.classList.add('is-searching');
        toggle.setAttribute('aria-expanded', 'true');
        requestAnimationFrame(() => input.focus());
        theme.events.emit('search:open', { input });
      };

      const close = () => {
        pill.classList.remove('is-searching');
        toggle.setAttribute('aria-expanded', 'false');
        input.value = '';
        theme.events.emit('search:close', { input });
        toggle.focus({ preventScroll: true });
      };

      toggle.addEventListener('click', (event) => {
        event.preventDefault();
        pill.classList.contains('is-searching') ? close() : open();
      });
      if (closeBtn) closeBtn.addEventListener('click', close);
      input.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') close();
      });
      theme.events.on('search:request-close', close);
    });

    /* ------------------------------------------------ Localization */
    header.querySelectorAll('[data-localization-select]').forEach((select) => {
      select.addEventListener('change', () => {
        const form = select.closest('form');
        if (form) form.submit();
      });
    });
  }

  function initAll(root = document) {
    root.querySelectorAll('[data-header]').forEach(initHeader);
    theme.updateHeaderHeight();
  }

  // Localization forms outside the header (footer)
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-localization-select]');
    if (!select || select.closest('[data-header]')) return;
    const form = select.closest('form');
    if (form) form.submit();
  });

  theme.onDocumentReady(() => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
